import { ref } from 'vue'

export const sectionOrderBus = ref(false)
